import "core-js/modules/es6.array.for-each";
import { useRef, useEffect } from 'react';
export function useOutside(type, handler) {
  var inside = useRef(null);
  useEffect(function () {
    var listener = function listener(evt) {
      if (inside.current && evt.target && !inside.current.contains(evt.target)) {
        handler(evt);
      }
    };

    var types = Array().concat(type);
    types.forEach(function (t) {
      return document.addEventListener(t, listener, true);
    });
    return function () {
      types.forEach(function (t) {
        return document.removeEventListener(t, listener, true);
      });
    };
  }, [type, handler, inside]);
  return inside;
}